var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4815 9.51843C61.1821 9.22039 60.8038 9.01404 60.3911 8.92364C59.9784 8.83324 59.5485 8.86255 59.1518 9.00812L10.3393 26.7581C9.91838 26.9178 9.55595 27.2018 9.3002 27.5723C9.04444 27.9428 8.90747 28.3824 8.90747 28.8326C8.90747 29.2829 9.04444 29.7225 9.3002 30.093C9.55595 30.4635 9.91838 30.7475 10.3393 30.9072L29.3984 38.5175L43.4653 24.4062L46.5937 27.5347L32.4603 41.6681L40.0928 60.7272C40.2572 61.14 40.5418 61.494 40.9097 61.7432C41.2776 61.9924 41.7118 62.1254 42.1562 62.125C42.6046 62.1158 43.0397 61.9709 43.4041 61.7095C43.7685 61.4481 44.0451 61.0824 44.1975 60.6606L61.9475 11.8481C62.0986 11.4556 62.1351 11.0281 62.0526 10.6157C61.9701 10.2032 61.772 9.82264 61.4815 9.51843Z",
    fill: "#FCC67C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d425ee439d22ec6ad8af54274f747db7.svg";
export { ForwardRef as ReactComponent };